var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-page',{attrs:{"title":_vm.$t('message.errorPage.applicationPreviouslySubmitted.title'),"sub-title":_vm.$t('message.errorPage.applicationPreviouslySubmitted.subTitle', { dealer: this.getBusinessName }),"icon":"paper-check"}})}
var staticRenderFns = []

export { render, staticRenderFns }